export const API_BASE_URL = 'https://staging-jayco.mydwsite.com';

/** Maximum number of additional sales persons allowed on unit registration */
export const MAX_ADDITIONAL_SALES_PERSONS = 1;
